import { Component, OnInit } from '@angular/core';
import { ProdutosPermitidosService } from '../produtos-permitidos.service';
import { ModalidadeOperacionalRepasse } from '../../../model/modalidade-operacional-repasse.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ModalProdutosPermitidosComponent } from '../modal-produtos-permitidos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-produtos-permitidos-pesquisa',
  standalone: false,
  templateUrl: './produtos-permitidos-pesquisa.html'
})
export class ProdutosPermitidosPesquisa implements OnInit {

  protected pesquisaForm: UntypedFormGroup = null;
  public pesquisado: boolean = false;
  public listaTodosProdutos: ModalidadeOperacionalRepasse[] = [];
  public produtosPermitidos: ModalidadeOperacionalRepasse[] = [];
  public listaOpercaoPermitida = [
    {
      nome: "Todos",
      valor: null
    },
    {
      nome: "Sim",
      valor: "S"
    },
    {
      nome: "Não",
      valor: "N"
    }
  ];


  constructor(private servico: ProdutosPermitidosService,
    private formBuilder: UntypedFormBuilder,
    private abrirModal: NgbModal) {
  }

  ngOnInit() {
    this.pesquisaForm = this.createReactiveForm();

    this.servico.listarTodos().subscribe(res => {
      this.listaTodosProdutos = res;
    });
  }

  buscar() {
    this.servico.listarTodosFiltrados(this.obterFiltrosBusca()).subscribe(res => {
      this.produtosPermitidos = res;
      this.pesquisado = true;
    });

  }

  obterFiltrosBusca() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;

    if (form.idProduto) {
      dadosPreenchidos.idProduto = form.idProduto;
    }

    if (form.permitido) {
      dadosPreenchidos.permitido = form.permitido;
    }

    return dadosPreenchidos;
  }


  limpar() {
    this.pesquisaForm.reset({
      idProduto: null,
      permitido: null
    });
    this.pesquisado = false;
    this.produtosPermitidos = [];
  }

  createReactiveForm(): UntypedFormGroup {

    const f = this.formBuilder.group({
      idProduto: null,
      permitido: null,
    });

    return f;
  }

  atualizarListagem() {
    this.buscar();
  }

  public chamaModalCadastroProdutosPermitidos() {


    const modalRef = this.abrirModal.open(ModalProdutosPermitidosComponent, {
      windowClass: 'modal-dialog-md',
      backdrop: 'static',
      size: 'lg'
    });

    modalRef.result.then((resultado) => {
      if (resultado.botao === 'salvar') {
        this.servico.listarTodos().subscribe(res => {
          this.listaTodosProdutos = res;
        });

        if(this.pesquisado){
           this.atualizarListagem();
        }

      }
    });
  }


}
